import Paper from './Paper';

export { Paper };
